import React from 'react';
import { Breadcrumb } from 'antd';
import './index.less'
export default ({ list }) => {
  return (
    <div className="bread-crumb-content">
      <Breadcrumb>
        {list.length > 0 && list.map((item, idx) =>
          <Breadcrumb.Item key={idx}>{item.title}</Breadcrumb.Item>
        )}
      </Breadcrumb>
    </div>
  )
}